import { Navigate, useParams } from 'react-router-dom';
import { Result, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { useGetDeviceTypeQuery } from 'app/services/devices';
import { DeviceType } from 'app/services/devices/types';
import { Paths } from 'constants/index';

// Target of the QR stickers: hands the code on to the overview of the device it is on.
// A logger always asks for its verification code, logged in or not.
const DeviceOverview = () => {
  const { t } = useTranslation();
  const { barcode = '' } = useParams<{ barcode: string }>();
  const { data, isLoading, isFetching } = useGetDeviceTypeQuery(barcode, { skip: !barcode });

  if (isLoading || isFetching) return <Skeleton active />;

  const encoded = encodeURIComponent(barcode);

  if (data?.Type === DeviceType.TOOL) return <Navigate to={Paths.TOOLS_OVERVIEW.replace(':barcode', encoded)} replace />;
  if (data?.Type === DeviceType.LOGGER) return <Navigate to={Paths.LOGGERS_OVERVIEW_CODE.replace(':barcode', encoded)} replace />;

  return <Result status="404" title={t('pages.devices.notfound')} />;
};

export default DeviceOverview;
